import validate from "/vercel/path0/v3/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/v3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/vercel/path0/v3/middleware/admin.ts"),
  auth: () => import("/vercel/path0/v3/middleware/auth.ts"),
  "check-view-permission": () => import("/vercel/path0/v3/middleware/check-view-permission.ts"),
  "has-permission": () => import("/vercel/path0/v3/middleware/has-permission.ts"),
  login: () => import("/vercel/path0/v3/middleware/login.ts"),
  "super-admin": () => import("/vercel/path0/v3/middleware/super-admin.ts"),
  "super-typewriter": () => import("/vercel/path0/v3/middleware/super-typewriter.ts"),
  "zuno-engineer": () => import("/vercel/path0/v3/middleware/zuno-engineer.ts")
}